import angularModule from 'Onboarding/angularModule/scripts/onboarding_module';
import { setupBrandNameProperties } from 'AppBranding';
import template from 'Onboarding/angularModule/views/onboarding.hybrid.login.html';
import cacheAngularTemplate from 'cacheAngularTemplate';

import logoSmall from 'images/onboarding/Logo-Small@2x.png';
import logoSmallQuantic from 'vectors/onboarding/quantic-logo-vert-color.svg';

const templateUrl = cacheAngularTemplate(angularModule, template);

angularModule.directive('onboardingHybridLogin', [
    '$injector',
    function factory($injector) {
        const NavigationHelperMixin = $injector.get('Navigation.NavigationHelperMixin');
        const $routeParams = $injector.get('$routeParams');
        const ConfigFactory = $injector.get('ConfigFactory');
        const EventLogger = $injector.get('EventLogger');

        return {
            restrict: 'E',
            templateUrl,
            scope: {},
            link(scope) {
                EventLogger.log('debug_onboarding_issue:onboarding_hybrid_login_init', {
                    params: { $routeParams },
                });

                NavigationHelperMixin.onLink(scope);

                const config = ConfigFactory.getSync();
                setupBrandNameProperties($injector, scope, { config });

                const isQuantic = config.isQuantic();

                Object.defineProperty(scope, 'logoSmall', {
                    get() {
                        if (isQuantic) {
                            return logoSmallQuantic;
                        }
                        return logoSmall;
                    },
                });

                scope.logoWidth = 50;
                scope.logoHeight = 50;

                scope.showBack = _.includes(['register', 'start'], $routeParams.previous);

                scope.goBack = () => {
                    const whereToGo =
                        $routeParams.previous === 'start'
                            ? '/onboarding/hybrid?finished'
                            : '/onboarding/hybrid/register';
                    scope.loadRoute(whereToGo);
                };
            },
        };
    },
]);
